import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
// fn.getUrlObj()
store.dispatch('user/authRouter', false)
// const env = 'env'
// const a = require(`../public/static/${env}.js`)
// console.log(a)
// 进度条
import 'nprogress/nprogress.css';
// 自定义全局样式
import '@/assets/style/global/index.less';
import "@/assets/style/vant/theme.less";
import '@/utils/flexible';

import PAGE_API from '@/apis/pageApi';
import HTTP_API from '@/apis/httpApi';
import fn from '@/utils/fn.ts';
fn.getUrlData()
import Component from 'vue-class-component';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
import { Button, Field, CellGroup, DropdownMenu, Icon,
    DropdownItem, Toast, Popup, Dialog, Checkbox, CheckboxGroup } from "vant";
Vue.use(Button).use(Field).use(CellGroup).use(DropdownMenu).use(Icon)
    .use(DropdownItem).use(Toast).use(Popup).use(Dialog).use(Checkbox).use(CheckboxGroup);
// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$PAGE_API = PAGE_API
Vue.prototype.$HTTP_API = HTTP_API

Vue.config.productionTip = false;

window.App = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
